import React from 'react';
import PropTypes from 'prop-types';
import OptimizedImage from './OptimizedImage';
import { Link } from 'react-router-dom';

class CategoryCard extends React.Component {
  componentDidMount() {
    const { fptiImpression, content: { categoryFPTI = '' } = {} } = this.props;
    fptiImpression({
      pageLink: categoryFPTI,
      category: 'parent'
    });
  }

  render() {
    const {
      content: {
        location = '',
        categoryHeader = '',
        categoryBody = '',
        categoryImageUrl = ''
      } = {},
      handleClick,
      isRecommendCategory = false
    } = this.props;

    return (
      <Link
        onClick={handleClick}
        to={`/${
          isRecommendCategory
            ? 'setup-recommendations?appcenter=true'
            : `appcenter/${location}`
        }`}
        className="category-card undo-link-styles add-focus-visible"
        style={isRecommendCategory ? { margin: '8px 0 0' } : {}}
      >
        <div className="category-card-text">
          <h3>{categoryHeader}</h3>
          <p>{categoryBody}</p>
        </div>
        <div className="category-card-image">
          <OptimizedImage
            imageUrl={categoryImageUrl}
            className={`category-card-image-optimized`}
          />
        </div>
      </Link>
    );
  }
}

CategoryCard.propTypes = {
  handleClick: PropTypes.func,
  fptiImpression: PropTypes.func,
  content: PropTypes.object,
  isRecommendCategory: PropTypes.bool
};

export default CategoryCard;
